/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { api, type ApiResult } from "./client";
import { PAGE_SIZE, type Paged } from "./registry";

export type ReferralSource = "REFERRAL_FORM" | "SCREENER" | "FAX";

export type ReferralListItem = {
  id: number;
  createdAt: string | null;
  status: string | null;
  source: ReferralSource;
  organizationName: string | null;
  providerName: string | null;
  clientNames: string[];
};

export type NamedRef = { id: number; name: string | null };

export type ReferredClientView = {
  id: number;
  type: string | null;
  isCareRecipient: boolean;
  serviceLine: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phoneNumber: string | null;
  dob: string | null;
  stateCode: string | null;
  userId: number | null;
};

export type SourceFax = {
  caseId: string;
  ehrFaxId: string;
  receivedAt: string | null;
};

export type ReferralDetail = {
  id: number;
  status: string | null;
  source: ReferralSource;
  note: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  archivedAt: string | null;
  archivedReason: string | null;
  organization: NamedRef;
  provider: NamedRef | null;
  clients: ReferredClientView[];
  sourceFax: SourceFax | null;
};

export function listReferrals(
  q: string,
  page: number,
  filter: string | null,
): Promise<ApiResult<Paged<ReferralListItem>>> {
  const params = new URLSearchParams({ page: String(page), pageSize: String(PAGE_SIZE) });
  if (q.trim() !== "") {
    params.set("q", q.trim());
  }
  if (filter) {
    params.set("filter", filter);
  }
  return api(`/v1/referrals?${params.toString()}`);
}

export function referralDetail(id: string): Promise<ApiResult<ReferralDetail>> {
  return api(`/v1/referrals/${encodeURIComponent(id)}`);
}
